import React from 'react';
import { ConfigContext, useRemoteConfigDriver } from '../hooks/useRemoteConfig';

export const ConfigProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const driver = useRemoteConfigDriver();

    return (
        <ConfigContext.Provider value={driver}>
            {children}
        </ConfigContext.Provider>
    );
};
